function initSmallLayoutAnimations(){
    //Standard to top link animation
    $('.top-link').on('click',function () {
        $('body,html').animate({
            scrollTop: 0
        }, prefersReducedMotion() ? 0 : 800);
    })
    var config = {
        root: null,
        rootMargin: '0px',
        threshold: [0, 0.25, 0.5, 0.70, 0.90, 1]
    };

    if (window.matchMedia('(min-width:992px)').matches){
        config = {
            root: null,
            rootMargin: '0px',
            threshold: [0,0.50, 0.90, 1]
        };
    }

    var observer = new IntersectionObserver(function(entries) {
        for (var i = 0; i < entries.length; i++) {
            const element = entries[i].target;
            if (window.matchMedia('(min-width:992px)').matches){
                if(entries[i].intersectionRatio >= 0.40){
                    element.classList.add('element-seen');
                }
            } else {
                if(entries[i].isIntersecting === true){
                    element.classList.add('element-seen');
                }
            }
        }
    }, config);

    setTimeout(function(){
        var elements = document.querySelectorAll('.frame-container-mask_ce_icon_and_text, .frame-container-mask_ce_customer, .frame-container-mask_ce_customer_slider');
        for (var i = 0; i < elements.length; i++) {
            observer.observe(elements[i]);
        }
    },2000)


    //intersectionObserver for Tccd Badges
    let badgeOptions = {
        root: null,
        rootMargin: '0px',
        threshold: [1]
    }

    let badgeObserver = new IntersectionObserver(function(entries) {
        for (var i = 0; i < entries.length; i++) {
            let badge = entries[i].target;
            if(entries[i].intersectionRatio >= 1) {
                badge.classList.add('tccd-animate');
            }
        }
    }, badgeOptions);

    let badgeElements = document.querySelectorAll('.tccd-logo');
    for (var i = 0; i < badgeElements.length; i++) {
        badgeObserver.observe(badgeElements[i]);
    }
}